var exports = {
  "X": "Scroller.module__scroller___c0RXdX",
  "x": "Scroller.module__scrollerTextarea___c0RXdX",
};

module.exports = exports;
